module.exports = "/images/lojavirtual.png?0c3d54bfd9bd40affeca2185dfe63be3";